/* eslint-disable eqeqeq */
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "react-toastify";
import { commonToast } from "../../Utils";
import { LoadingButton } from "../../Utils/CustomComponent";
import FormBox from "../../components/FormBox/FormBox";
import CustomBreadCrumbs from "../../components/CustomBreadCrumbs";
import { brokerForm4 } from "./brokerFormConst";
import MultipleFormBoxComp from "../../components/FormBox/MultipleFormBoxComp";

const VOM = () => {
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm({ mode: "onBlur" });

  const [submitLoading, setSubmitLoading] = useState(false);
  const onSubmit = async (data) => {
    setSubmitLoading(true);
    const id = toast.loading("Loan Submission Pending");

    try {
      // const headers = {
      //   headers: {
      //     "Content-Type": "application/json",
      //   },
      // };
      // await axios.post(
      //   urls.submitaLoan.postSubmitaLoan(),
      //   {
      //     user_id: localStorage.getItem("apex_userid"),
      //     loan_submission_details: data,
      //   },
      //   headers
      // );
      toast.update(id, {
        render: "Loan Submitted Succesfuly",
        type: "success",
        isLoading: false,
        ...commonToast,
      });
      setSubmitLoading(false);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <div style={{ overflowY: "scroll" }}>
      <section
        className=" rounded"
        style={{ background: "#eeeeee", minHeight: "100vh" }}
      >
        <CustomBreadCrumbs
          crumbs={[
            { title: "Broker Forms", link: "/broker/forms" },
            { title: "Verification Of Mortgage Form" },
          ]}
        />
        <article className="container-fluid">
          <section className="bg-white p-5 my-2 mx-4">
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="loans-in-details mt-5">
                {brokerForm4?.map((data, index) => {
                  return (
                    <MultipleFormBoxComp
                      key={index}
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      options={data.arr}
                      errors={errors}
                    />
                  );
                })}
                <div className="col-sm-10">
                  <LoadingButton
                    loading={submitLoading}
                    type="submit"
                    title={"Submit"}
                  />
                </div>
              </div>
            </form>
          </section>
        </article>
      </section>
    </div>
  );
};
export default VOM;


